import ConfirmationDialog from '../../components/dialog/ConfirmationDialog';
import './LogoutConfirmation.scss';
import { logout } from '../../services/LoginService';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

const defaultProps = {
  title: 'Exit Vizzle',
  message: 'Are you sure you want to exit Vizzle?',
  open: false,
  onConfirm: () => null,
  onClose: () => null,
};

const LogoutConfirmation = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { title, message, open, onConfirm, onClose } = mergedProps;
  if (!open) {
    return null;
  }
  return (
    <ConfirmationDialog
      open={open}
      title={title}
      contentText={(
        <div>
          {message}
        </div>
      )}
      confirmLabel='Ok'
      cancelLabel='Cancel'
      onConfirm={async () => {
        await logout();
        onConfirm();
        onClose();
      }}
      onCancel={() => { onClose(); }}
      confirmClass='wide-button'
      cancelClass='wide-button'
      autoFocusCancelButton={false}
    />
  );
};

export default LogoutConfirmation;
